<template>
    <div class="">
        <div class="uk-text-left ml-3vw">
            <img width="10%" src="https://trainingvideocompliance.s3.amazonaws.com/KIR+Logo+w+AAA+on+Hat.JPG">
        </div>
        <h1 class="mt-05vh">{{ title }}</h1>
        <hr class="divider">
        <div class="uk-child-width-1-2@s uk-grid-match uk-padding" uk-grid>
            <div class="uk-position-relative">
                <div v-for="(item, index) in modules" 
                    :key="index"
                    class="transition-all cursor-pointer card"
                    @click="selectTrainingModule(item)">
                    <div v-if="item.user_history.passed === true" style="right: 10px; top: 10px; text-align:right" class="uk-position-absolute">
                        <img width="10%" src="https://trainingvideocompliance.s3.amazonaws.com/KIR+Logo+w+AAA+on+Hat.JPG">
                    </div>
                    <div class="uk-card-primary uk-card-body transition-all">
                        <h5 style="margin-bottom: 0px" v-if="item.user_history.last_event.event_order > 1">{{ Math.floor(((item.user_history.last_event.event_order+1)/item.event_count)*100) }}% Complete </h5>
                        <h3 class="uk-card-title">{{ item.title }}</h3>
                        <p>{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        modules: {
            type: Array,
            default: function(){
                return []
            }
        },
        frameNum:{
            type: Number,
            default: 0
        },
        nextFrame:{
            type: Function
        },
        title:{
            type: String,
            default: "Training Modules"
        }
    },
    data: function() {
        return {
            width: window.innerWidth
        }
    },
    methods: {
        selectTrainingModule(item){
            // this.nextFrame(this.frameNum+1)
            let data = {module:item, itemnum:this.frameNum}
            this.$emit('selectModule',data)
        }
    }
}
</script>

<style lang="less" scoped>

    .ml-3vw {
        margin-left: 3vw;
    }
    .mt-05vh {
        margin-top: 0.5vh;
    }
    h1 {
        text-align: center;
    }
    .transition-all {
        transition: all 333ms ease-in-out;
    }

    .cursor-pointer {
        cursor: pointer;
    }
    .divider {
        border: 2px solid #000000;
        margin: 0px 100px;
    }
    .card:hover {
        transform: translateY(-5px);
        box-shadow: 0px 5px 15px #a9a9a9;

    }
</style>
